module.exports = __webpack_public_path__ + "static/img/8.0fda97a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/12/sp/8.png
// module id = jUwO
// module chunks = 0